import { theme } from "../../../../theme";
import Label from "../../common/Label";
import TotalCard from "../../common/TotalCard";
import PriceCheckAllDetails from "../priceCheckDetails/PriceAllDetails";
import FixedCharges from "./FixedCharges";

const Price = ({ 
    skill, 
    jobRatePreHour, 
    confirmBooking, 
    isHome = false, 
    calculateFutureTime, 
    range 
}) => {
    return (
        <div className="card h-100 border border-dark">
            <span className={`badge rounded-pill bg-${theme.main} text-light text-bolder w-50 mt-n3 mx-auto mb-4`}>
                Price
            </span>

            <PriceCheckAllDetails
                skill={skill}
                jobRatePreHour={jobRatePreHour}
                isHome={isHome}
                calculateFutureTime={calculateFutureTime}
                range={range}
            />

            <div className="mt-1 mx-3">
                <Label text="Fee" showIcon={true} />
            </div>

            <div className="card-body text-lg-start text-center pt-0">
                <FixedCharges isHome={isHome} />
            </div>

            <TotalCard jobRatePreHour={jobRatePreHour} isHome={isHome} />

            <div className="card-footer text-center pt-0">
                <button
                    type="button"
                    aria-label="Join service"
                    className={`btn btn-icon bg-gradient-${theme.main} d-lg-block mt-3 mb-0 w-100`}
                    onClick={confirmBooking}
                >
                    <span className="btn-inner--icon">
                        <i className="material-symbols-rounded">orders</i>
                    </span>
                    &nbsp;
                    <span className="btn-inner--text">Confirm Booking</span>
                </button>
            </div>
        </div>
    );
};

export default Price;